import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-auth-layout',
  imports: [RouterOutlet, CommonModule],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss'
})
export class AuthLayoutComponent implements OnInit, OnDestroy {
  currentSlide = 0;
  slides = [
    { title: 'Dashboard Overview', description: 'Complete analytics and insights' },
    { title: 'Contacts & Leads', description: 'Manage your customer relationships' },
    { title: 'Analytics & Reports', description: 'Data-driven decision making' }
  ];
  
  private intervalId: any;
  private readonly SLIDE_DURATION = 4000; // 4 seconds
  private isPaused = false;

  ngOnInit() {
    this.startAutoSlide();
  }

  ngOnDestroy() {
    this.stopAutoSlide();
  }

  startAutoSlide() {
    if (!this.isPaused) {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, this.SLIDE_DURATION);
    }
  }

  stopAutoSlide() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  pauseAutoSlide() {
    this.isPaused = true;
    this.stopAutoSlide();
  }

  resumeAutoSlide() {
    this.isPaused = false;
    this.startAutoSlide();
  }

  goToSlide(index: number) {
    this.currentSlide = index;
    this.stopAutoSlide();
    setTimeout(() => this.startAutoSlide(), 1000); // Restart auto-slide after manual navigation
  }

  nextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
  }

  previousSlide() {
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.stopAutoSlide();
    setTimeout(() => this.startAutoSlide(), 1000); // Restart auto-slide after manual navigation
  }
}
